export enum NewsFormActionsEnum {
  NEWS_FORM_ADD = 'NEWS_FORM_ADD',
  NEWS_FORM_GET_SINGLE_NEWS = 'NEWS_FORM_GET_SINGLE_NEWS',
  NEWS_FORM_SET_SINGLE_NEWS = 'NEWS_FORM_SET_SINGLE_NEWS',
  NEWS_FORM_UPDATE = 'NEWS_FORM_UPDATE',
  NEWS_FORM_SET_NEWS_ID = 'NEWS_FORM_SET_NEWS_ID',
}
